import React from 'react';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import { DelayedSmartPageCustomDomainStepWithI18n } from './delayed-smart-page-custom-domain-step';

export const SmartPageCustomDomainStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_CUSTOM_DOMAIN,
  render: () => <DelayedSmartPageCustomDomainStepWithI18n />,
};
